import axios from './BaseService';

const FEEDBACK_URL = `${
    process.env.REACT_APP_API_URL || window._env_?.REACT_APP_API_URL
}/feedback/`;

export async function getFeedback({ status, type, page } = {}) {
    const params = new URLSearchParams();
    if (status) params.set('status', status);
    if (type) params.set('type', type);
    if (page) params.set('page', page);

    const query = params.toString();
    const response = await axios.get(
        `${FEEDBACK_URL}${query ? `?${query}` : ''}`,
    );
    return response.data; // { rows, count }
}

export async function updateFeedbackStatus(id, status) {
    const response = await axios.patch(`${FEEDBACK_URL}${id}/status`, {
        status,
    });
    return response.data;
}
